<!-- One definition of a leaf block, reused at the top level and inside every column. -->
<ng-template #leaf let-block>
  @switch (block.kind) {
    @case ('bar') {
      <app-skeleton [width]="block.width ?? '100%'" [height]="block.height ?? '14px'" />
    }
    @case ('tiles') {
      <div
        class="ws-tiles"
        [style.grid-template-columns]="
          'repeat(auto-fit, minmax(' + (block.min ?? '104px') + ', 1fr))'
        "
      >
        @for (tile of countOf(block.count); track tile) {
          <app-skeleton [height]="block.height ?? '58px'" />
        }
      </div>
    }
    @case ('rows') {
      <div class="ws-rows">
        @for (row of countOf(block.count); track row) {
          <div class="ws-row">
            @if (block.lead === 'circle') {
              <app-skeleton shape="circle" width="26px" height="26px" />
            } @else if (block.lead === 'box') {
              <app-skeleton width="52px" height="38px" />
            }
            <div class="ws-row-body">
              <app-skeleton width="55%" height="13px" />
              <app-skeleton width="80%" height="11px" />
            </div>
            @if (block.trailing !== false) {
              <app-skeleton width="62px" height="18px" />
            }
          </div>
        }
      </div>
    }
  }
</ng-template>

<div class="ws">
  @for (block of blocks(); track $index) {
    @switch (block.kind) {
      @case ('panel') {
        <div class="ws-panel" [style.min-height]="block.height ?? '110px'">
          @for (line of countOf(block.lines ?? 3); track line) {
            <app-skeleton [width]="line === 0 ? '40%' : '70%'" height="16px" />
          }
        </div>
      }
      @case ('columns') {
        <div
          class="ws-columns"
          [class.has-accent]="block.accentTop"
          [class.is-stacked]="block.stack"
          [style.min-height]="block.height ?? '200px'"
        >
          @for (column of block.columns; track $index) {
            <div
              class="ws-column"
              [attr.data-tone]="column.tone ?? null"
              [style.flex-grow]="column.flex ?? 1"
            >
              @for (inner of column.blocks; track $index) {
                <ng-container
                  [ngTemplateOutlet]="leaf"
                  [ngTemplateOutletContext]="{ $implicit: inner }"
                />
              }
            </div>
          }
        </div>
      }
      @default {
        <ng-container [ngTemplateOutlet]="leaf" [ngTemplateOutletContext]="{ $implicit: block }" />
      }
    }
  }
</div>
